import { render } from "./Header.vue?vue&type=template&id=31c522ef&ts=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=31c522ef&lang=scss"

import exportComponent from "/var/www/tenanthub.au/runners/admin/root/tenanthub-admin/tenanthub-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__